<template>
    <div class="green-border-box in-padd white-bg row" style="min-height:400px;">
      <div class="sort-control" style="margin-bottom:20px;">
        Filter By
        <div style="display:inline-flex;margin-left:10px;">
          <date-range-picker
             v-model="dateRange"
             :opens="'center'"
             :date-format="dateFormat"
             :locale-data="{format: 'dd-mm-yyyy' }"
             :autoApply="true"
             @update="updateList"
             style="width:100%;margin:auto;"
           >
           <template v-slot:input="picker" style="min-width:350px;">
              {{ picker.startDate.toDateString() }} - {{ picker.endDate.toDateString() }}
           </template>
           </date-range-picker>
        </div><br/>
        <select v-model="storeId" @change="updateList" style="margin-top: 10px;margin-left:0px;">
          <option value="" selected>  Select Physical Location </option>
            <option v-for="store in stores" :key="store.id" :value="store.id">{{store.name}}</option>
        </select>
        <select v-model="state" @change="updateList" style="margin-bottom:15px;">
          <option value="" selected> State</option>
            <option v-for="state in states" :key="state.name">{{state.name}}</option>
        </select>
        <select v-model="taskId" @change="updateList" style="margin-left:15px;">
          <option value="" selected>  Image Type</option>
            <option v-for="task in tasks" :key="task.id" :value="task.id">{{task.name}}</option>
        </select>
        <select v-model="productId" @change="updateList">
          <option value="" selected> Activities & Products </option>
            <option v-for="product in products" :key="product.id" :value="product.id">{{product.name}}</option>
        </select>
        <select v-model="socialSelfie" @change="updateList">
          <option value="0" selected> Social Selfies</option>
            <option value="1">Yes</option>
        </select>
        <br/>
        <select v-model="limit" @change="updateList" style="float:right;">
          <option value="8">8 per page</option>
          <option value="25">25 per page</option>
          <option value="50">50 per page</option>
          <option value="75">75 per page</option>
          <option value="100">100 per page</option>

        </select>

        <h6 class="totalCount">Total Images: {{ totalCount }}</h6>

        <button @click="toggleSelectable" class="btn btn-positive" style="float:right;">{{toggleSelectableButtonName}}</button>
        <button v-if="showsDownloadSelectedImagesButton" @click="downloadSelectedImages" class="btn btn-positive" style="float:right;">Download Selected Images</button>
        <br/><br/>
      </div>
      <div v-if="images.length > 0" class="row">
        <viewer
          :images="images"
          :options="viewerOptions"
        >
        <div v-for="(image, index) in images" :key="index">
              <div class="col-xs-6 col-md-3" style="margin-bottom:20px;" :class="selectablePicklDiv?'selectable':''">
                <div class="photo green-border-box"  style="border: 1px solid black !important;">
                  <div class="img-contain" style=" position:relative;overflow:hidden;">
                    <input type="checkbox" class="selecteble-check" v-model="selectedPicklsList[index]" :value="index" v-show="selectablePicklDiv"/>
                    <img
                      :src="image.image + lowSrcQuery" :alt="image.name" style="width:100%;height:100%;"
                    />
                    <div class="img-overlay">
                      <span style="display:block;text-align:center;font-size:15px;color: white;background: rgba(0, 0, 0, .6);padding: 3%;" class="vertical-center-transform">{{image.name}}</span>
                      <span style="display:block;text-align:center;font-size:18px;margin-top:5px;margin-bottom:5px;"> {{image.storeName?image.storeName + ' | ' :''}} {{image.state?image.state : 'NA'}}</span>
                    </div>
                  </div>
                </div>
              </div>
        </div>
       </viewer>
      </div>
      <div v-if="!loading && hasMoreImages" class="row" style="text-align:center;">
       <button class="btn btn-positive" style="margin-top:20px;" @click="loadMore">Load More</button>
      </div>
      <div v-if="!loading && images.length == 0">
        <h3 style="text-align:center;margin-top:50px;">No Pickl Task Images found!</h3>
      </div>
      <div v-if="loading">
        <h3 style="text-align:center;margin-top:50px;">Loading Images</h3>
      </div>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import App from './../../App.vue'

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
export default {
  name: 'Picklr',
  components: {
    DateRangePicker,
    App
  },
  data () {
    return {
      isDownloading: false,
      hasMoreImages: false,
      showsDownloadSelectedImagesButton: false,
      selectedPicklsList: [],
      finalSelectedImagesList: [],
      selectablePicklDiv: false,
      toggleSelectableButtonName: 'Select Images',
      loading: true,
      totalCount: 0,
      dateRange: {
        endDate: new Date(),
        startDate: new Date()
      },
      images: [],
      tasks: [],
      stores: [],
      storeId: '',
      lowSrcQuery: '?w=200&q=80&h=200&fit=crop',
      limit: 8,
      offset: 0,
      productId: '',
      taskId: '',
      brandId: this.$store.state.userData.brandId,
      state: '',
      socialSelfie: 0,
      states: [],
      products: [],
      viewerOptions: {
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 0,
          reset: 0,
          prev: {
            size: 'large'
          },
          play: 0,
          next: {
            size: 'large'
          },
          rotateLeft: 1,
          rotateRight: 1,
          flipHorizontal: 0,
          flipVertical: 0
        },
        filter: function (image) {
          return !image.src.endsWith('/img/Alerts/timeGreen_icon.png')
        },
        title: [
          1,
          function (image, imageData) {
            return image.alt
          }
        ],
        url: image => {
          return image.src.replace(this.lowSrcQuery, '')
        }
      }
    }
  },
  mounted () {
    this.getBrandImages()
    this.getBrandUsedTasks()
    this.getStates()
    this.getProducts()
    this.getBrandUsedStores()
  },
  watch: {
    selectedPicklsList () {
      if (this.selectedPicklsList.filter(item => item).length > 0) {
        this.showsDownloadSelectedImagesButton = true
      } else {
        this.showsDownloadSelectedImagesButton = false
      }
      console.log(this.selectedPicklsList.filter(item => item).length)
    }
  },
  methods: {
    loadMore () {
      this.offset += this.limit
      this.getBrandImages()
    },
    async downloadSelectedImages () {
      console.log(this.selectedPicklsList)
      this.isDownloading = true
      this.$store.commit('showLoading', 'Downloading Images...')

      let imageUrls = []
      this.selectedPicklsList.forEach((item, index) => {
        if (item === true) {
          imageUrls.push({
            url: this.images[index].image, name: this.images[index].name, storeName: this.images[index].storeName, state: this.images[index].state
          })
        }
      })
      console.log(imageUrls)
      const zip = new JSZip()
      const folder = zip.folder('images')
      // Fetch and add images to the zip folder
      const imagePromises = imageUrls.map(async (item, index) => {
        const response = await fetch(item.url)
        const blob = await response.blob()
        let imageName = item.name.replace(/\//g, ' ') + ' ' + index + 1
        folder.file(`${item.state}/${item.storeName}/image_${imageName}.png`, blob)
      })
      // Wait for all images to be fetched and added to the zip folder
      await Promise.all(imagePromises)
      // Generate the zip file and trigger download
      const zipBlob = await zip.generateAsync({ type: 'blob' })
      saveAs(zipBlob, 'Task_Images.zip')
      this.isDownloading = false
      this.$store.commit('hideMessage')
    },
    toggleSelectable () {
      this.selectablePicklDiv = !this.selectablePicklDiv
      this.toggleSelectableButtonName = this.selectablePicklDiv ? 'Cancel' : 'Select Images'
    },
    performClickAction (index) {
      console.log(index)
    },
    updateList () {
      this.images = []
      this.offset = 0
      this.getBrandImages()
    },
    getBrandImages () {
      this.loading = true
      let filters = {
        brandId: this.brandId,
        limit: this.limit,
        offset: this.offset,
        productId: this.productId,
        taskId: this.taskId,
        storeId: this.storeId,
        state: this.state,
        socialSelfie: this.socialSelfie
      }
      if (!(this.dateRange.startDate.getDate() === this.dateRange.endDate.getDate() && this.dateRange.startDate.getMonth() === this.dateRange.endDate.getMonth() && this.dateRange.startDate.getFullYear() === this.dateRange.endDate.getFullYear())) {
        filters.startDate = this.dateRange.startDate.toISOString().split('T')[0]
        filters.endDate = this.dateRange.endDate.toISOString().split('T')[0]
      }
      this.$store.dispatch('getBrandImages', filters).then((response) => {
        this.images.push(...response.body.images)
        this.totalCount = response.body.count
        if (this.limit + this.offset < response.body.count) {
          this.hasMoreImages = true
        } else {
          this.hasMoreImages = false
        }
        this.loading = false
      })
    },
    getBrandUsedTasks () {
      this.$store.dispatch('getBrandUsedTasks', { brandId: this.brandId }).then((response) => {
        this.tasks = response.body
      })
    },
    getBrandUsedStores () {
      this.$store.dispatch('getBrandUsedStores', { brandId: this.brandId }).then((response) => {
        this.stores = response.body
      })
    },
    getProducts () {
      this.$store.dispatch('getProductsList', { brand_id: this.brandId, limit: 100, offset: 0, query: '' }).then((response) => {
        this.products = response.response.body.data
      })
    },
    getStates () {
      this.$store.dispatch('getStates').then((response) => {
        this.states = response.body.data
      })
    },
    dateFormat (classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() > new Date()
      }
      return classes
    }
  }
}

</script>

<style scoped>

.selectable {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  /* animation: shake 1s;

  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}
.selectable > div {
  border: dotted 1px gray;
}
@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0) rotate(-0.1deg);
  }
  20%, 80% {
    transform: translate3d(1px, 0, 0) rotate(0.1deg);
  }
  30%, 50%, 70% {
    transform: translate3d(-1px, 0, 0) rotate(-0.1deg);
  }
  40%, 60% {
    transform: translate3d(1px, 0, 0) rotate(0.1deg);
  }
}

.selecteble-check {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  left: 0;
  top: -3;
  opacity: 0.3;
}

.selecteble-check:checked + .img-contain .img-overlay {
  background: rgba(0, 0, 0, .6);
}

@media only screen and (max-width: 575px) {
    .item-list >>> .outer-box span {
        white-space: normal;
        word-wrap: break-word;
    }
}

.span-published {
  width: 198px;
  text-align: left;
  left: 7417px;
  top: 1925px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #792b54;
  display: block;
}
.pickl {
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
}

.pickl.disabled {
  cursor: auto;
  cursor: not-allowed;
  pointer-events: none;
  background: repeating-linear-gradient(
    45deg,
    #fff,
    #fff 20px,
    #ddd 20px,
    #ddd 40px
  );
}
.vertical-center-transform {
  width: 100%;
  text-align: center;
}
.overlay .vertical-center-transform {
  color: white;
}

/* .overlay {
  display: none;
  background: rgba(0, 0, 0, 0.65);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 20px;
  color: white;
  font-weight: 700;
  letter-spacing: 1px;
}

.pickl.disabled .overlay {
  display: block;
} */

.pickl.disabled .status {
  color: #000 !important;
  font-weight: 700;
}

.top-part {
  padding: 15px;
}

.middle-part {
  padding: 0 15px 15px;
}

.top-part h4,
.top-part h5 {
  padding: 0 75px;
  margin: 0;
  line-height: 30px;
  height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.top-part h4 {
  font-weight: 500;
  font-size: 22px;
  color: rgba(0, 0, 0, 0.9);
}

.top-part h5 {
  font-size: 17px;
  color: rgba(0, 0, 0, 0.65);
}

.product-logo {
  left: auto;
  right: 0;
}

.middle-part .address {
  font-size: 17px;
  color: black;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

.middle-part .address:last-child {
  margin-bottom: 15px;
}

.middle-part .status {
  font-size: 19px;
  font-weight: 500;
}

.bottom-part {
  padding: 15px 0;
  background: #f7f8f9;
  font-weight: 500;
  font-size: 19px;
  color: rgba(0, 0, 0, 0.8);
  vertical-align: text-top;
  line-height: 35px;
}

.bottom-part img {
  vertical-align: text-top;
  margin-right: 3px;
}

.bottom-part .pickl-date {
  border-right: 1px solid #cfd1d3;
}

.rating {
  margin-bottom: 15px;
}

.rating img {
  width: 13px;
  height: 12px;
  margin-right: 3px;
}

.rating img:last-child {
  margin-right: 0;
}

@media only screen and (min-width: 1096px) and (max-width: 1199px) {
  .bottom-part {
    font-size: 15px;
    line-height: 30px;
  }

  .bottom-part > div {
    padding-left: 0;
    padding-right: 0;
  }

  .bottom-part img {
    height: 17px;
    width: auto;
  }
}

@media only screen and (max-width: 767px) {
  .bottom-part {
    padding: 0 15px;
  }

  .bottom-part .pickl-date,
  .bottom-part .pickl-time {
    padding: 10px 0;
  }

  .bottom-part .pickl-date {
    border-bottom: 1px solid #cfd1d3;
    border-right: none;
  }
}

.grayed {
  background: repeating-linear-gradient(
    45deg,
    #fff,
    #fff 20px,
    #ddd 0,
    #ddd 40px
  );
}

@media only screen and (max-width: 575px) {
  .company-logo {
    left: 20%;
  }

  .product-logo {
    right: 20%;
  }

  .top-part h4 {
    padding: 0;
    padding-top: 70px;
  }
  .top-part h5 {
    padding: 0;
  }
}
.coupon-side-details {
  background: #fff;
  /* border-radius: 50%; */
  /* width: 60px; */
  /* height: 60px; */
  /* border: 1px solid rgba(116, 116, 116, 0.94); */
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}
.right-align {
  left: auto;
  right: 0;
}
.short-description {
  font-size: 17px;
}
.float-left {
  float: left;
}
.text-left {
  text-align: left;
}
.text-right {
    text-align: right;
}
.float-right {
  float: right;
}
.inline-right-check {
  display: inline;
}
.black {
  color:black;
}
.coupon-used {
color: black;
}

.upgrade-link {
    color: #782b54;
}
.upgrade-link:hover {
    text-decoration: none;
}
.totalCount{
    font-size: 13px;
    background: #BDA340;
    padding: 9px 15px;
    max-width: 135px;
    text-align: center;
    border-radius: 14px;
}
</style>
